const actions = {
  MINING_DASHBOARD_DATA_BEGIN: "MINING_DASHBOARD_DATA_BEGIN",
  MINING_DASHBOARD_DATA_SUCCESS: "MINING_DASHBOARD_DATA_SUCCESS",
  MINING_DASHBOARD_DATA_ERR: "MINING_DASHBOARD_DATA_ERR",

  MINING_DASHBOARD_CATEGORY_DETAILS_BEGIN:
    "MINING_DASHBOARD_CATEGORY_DETAILS_BEGIN",
  MINING_DASHBOARD_CATEGORY_DETAILS_SUCCESS:
    "MINING_DASHBOARD_CATEGORY_DETAILS_SUCCESS",
  MINING_DASHBOARD_CATEGORY_DETAILS_ERR:
    "MINING_DASHBOARD_CATEGORY_DETAILS_ERR",

  SUBMIT_MINING_AUDIO_DATA_BEGIN: "SUBMIT_MINING_AUDIO_DATA_BEGIN",
  SUBMIT_MINING_AUDIO_DATA_SUCCESS: "SUBMIT_MINING_AUDIO_DATA_SUCCESS",
  SUBMIT_MINING_AUDIO_DATA_ERR: "SUBMIT_MINING_AUDIO_DATA_ERR",

  POST_MINING_AUDIO_DATA_BEGIN: "POST_MINING_AUDIO_DATA_BEGIN",
  POST_MINING_AUDIO_DATA_SUCCESS: "POST_MINING_AUDIO_DATA_SUCCESS",
  POST_MINING_AUDIO_DATA_ERR: "POST_MINING_AUDIO_DATA_ERR",

  MINING_AUDIO_DATA_BEGIN: "MINING_AUDIO_DATA_BEGIN",
  MINING_AUDIO_DATA_SUCCESS: "MINING_AUDIO_DATA_SUCCESS",
  MINING_AUDIO_DATA_ERR: "MINING_AUDIO_DATA_ERR",

  STORE_LIST_BEGIN: "STORE_LIST_BEGIN",
  STORE_LIST_SUCCESS: "STORE_LIST_SUCCESS",
  STORE_LIST_ERR: "STORE_LIST_ERR",

  MINING_CATEGORY_LIST_BEGIN: "MINING_CATEGORY_LIST_BEGIN",
  MINING_CATEGORY_LIST_SUCCESS: "MINING_CATEGORY_LIST_SUCCESS",
  MINING_CATEGORY_LIST_ERR: "MINING_CATEGORY_LIST_ERR",

  MINING_LISTEN_HOURS_BEGIN: "MINING_LISTEN_HOURS_BEGIN",
  MINING_LISTEN_HOURS_SUCCESS: "MINING_LISTEN_HOURS_SUCCESS",
  MINING_LISTEN_HOURS_ERR: "MINING_LISTEN_HOURS_ERR",

  getMiningDashboardDataBegin: () => {
    return {
      type: actions.MINING_DASHBOARD_DATA_BEGIN,
    };
  },

  getMiningDashboardDataSuccess: (data) => {
    return {
      type: actions.MINING_DASHBOARD_DATA_SUCCESS,
      data,
    };
  },

  getMiningDashboardDataErr: (err) => {
    return {
      type: actions.MINING_DASHBOARD_DATA_ERR,
      err,
    };
  },

  getMiningDashboardCategoryDetailsBegin: () => {
    return {
      type: actions.MINING_DASHBOARD_CATEGORY_DETAILS_BEGIN,
    };
  },

  getMiningDashboardCategoryDetailsSuccess: (data) => {
    return {
      type: actions.MINING_DASHBOARD_CATEGORY_DETAILS_SUCCESS,
      data,
    };
  },

  getMiningDashboardCategoryDetailsErr: (err) => {
    return {
      type: actions.MINING_DASHBOARD_CATEGORY_DETAILS_ERR,
      err,
    };
  },

  getMiningAudioDataBegin: () => {
    return {
      type: actions.MINING_AUDIO_DATA_BEGIN,
    };
  },

  getMiningAudioDataSuccess: (data) => {
    return {
      type: actions.MINING_AUDIO_DATA_SUCCESS,
      data,
    };
  },

  getMiningAudioDataErr: (err) => {
    return {
      type: actions.MINING_AUDIO_DATA_ERR,
      err,
    };
  },

  postMiningAudioDataBegin: () => {
    return {
      type: actions.POST_MINING_AUDIO_DATA_BEGIN,
    };
  },

  postMiningAudioDataSuccess: (data) => {
    return {
      type: actions.POST_MINING_AUDIO_DATA_SUCCESS,
      data,
    };
  },

  postMiningAudioDataErr: (err) => {
    return {
      type: actions.POST_MINING_AUDIO_DATA_ERR,
      err,
    };
  },

  submitMiningAudioDataBegin: () => {
    return {
      type: actions.SUBMIT_MINING_AUDIO_DATA_BEGIN,
    };
  },

  submitMiningAudioDataSuccess: (data) => {
    return {
      type: actions.SUBMIT_MINING_AUDIO_DATA_SUCCESS,
      data,
    };
  },

  submitMiningAudioDataErr: (err) => {
    return {
      type: actions.SUBMIT_MINING_AUDIO_DATA_ERR,
      err,
    };
  },

  getStoreListBegin: () => ({
    type: actions.STORE_LIST_BEGIN,
  }),

  getStoreListSuccess: (data) => ({
    type: actions.STORE_LIST_SUCCESS,
    data,
  }),

  getStoreListErr: (err) => ({
    type: actions.STORE_LIST_ERR,
    err,
  }),

  getMiningCategoryListBegin: () => ({
    type: actions.MINING_CATEGORY_LIST_BEGIN,
  }),

  getMiningCategoryListSuccess: (data) => ({
    type: actions.MINING_CATEGORY_LIST_SUCCESS,
    data,
  }),

  getMiningCategoryListErr: (err) => ({
    type: actions.MINING_CATEGORY_LIST_ERR,
    err,
  }),

  getMiningListenHoursBegin: () => ({
    type: actions.MINING_LISTEN_HOURS_BEGIN,
  }),
  getMiningListenHoursSuccess: (data) => ({
    type: actions.MINING_LISTEN_HOURS_SUCCESS,
    data,
  }),
  getMiningListenHoursErr: (err) => ({
    type: actions.MINING_LISTEN_HOURS_ERR,
    err,
  }),
};

export default actions;
